import {State} from '../types'

export const isCouponsAccepted = (state: State) => state.checkoutOptions.options.acceptCoupons

export const isUpgradeNeeded = (state: State) => !state.checkoutOptions.options.premiumServices
